export function getRounded(
  value,
  decimalPlaces = 2,
  convertToLocaleString = false,
) {
  if (!value && value !== 0) return null;

  const rounded = Number(
    `${Math.round(parseFloat(`${value}e${decimalPlaces}`))}e-${decimalPlaces}`,
  );

  return convertToLocaleString ? rounded.toLocaleString() : rounded;
}

export const ROUNDING_DIRECTIONS = {
  NEAREST: 'nearest',
  UP: 'up',
  DOWN: 'down',
};

export function normalizeToRange(
  value,
  step,
  direction = ROUNDING_DIRECTIONS.NEAREST,
  start = 0,
  convertToLocaleString = false,
) {
  if (!value && value !== 0) return null;

  let normalized = 0;
  if (direction === ROUNDING_DIRECTIONS.DOWN) {
    normalized = Math.floor((value - start) / step) * step + start;
  } else if (direction === ROUNDING_DIRECTIONS.UP) {
    normalized = Math.ceil((value - start) / step) * step + start;
  } else {
    normalized = Math.round((value - start) / step) * step + start;
  }

  return convertToLocaleString ? normalized.toLocaleString() : normalized;
}

/**
 * Chunks an array into a collection of smaller arrays based on a given chunk size.
 * @param {Array} arr - The input array to break into chunks.
 * @param {Number} chunkSize - The chunk size.
 */
export function chunkArray(arr, chunkSize = 10) {
  return arr.reduce((acc, cur, idx) => {
    const chunkIndex = Math.floor(idx / chunkSize);

    if (!acc[chunkIndex]) {
      acc[chunkIndex] = [];
    }

    acc[chunkIndex].push(cur);

    return acc;
  }, []);
}
